import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Typography,
} from '@mui/material'
import React, { FC, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { ChargeException } from '../../../../../api/models/ChargeException.type'
import {
  CongestionZoneVAT,
  FeeType,
} from '../../../../../api/models/Common/JyrneyEnums'
import FormInput from '../../../../FormFields/FormInput/FormInput'
import FormSelect from '../../../../FormFields/Select/FormSelect'
import styles from './additionalChargesStyle'

interface CreateAdditionalChargesProps {
  options: ChargeException[]
  index: number
  isEdit: boolean
  setDrawerVisible: React.Dispatch<React.SetStateAction<boolean>>
  additionalCharges: any
  setAdditionalCharges: React.Dispatch<React.SetStateAction<any>>
}

export const getAdornmentProps = (value: string) => {
  if (value === 'Fixed') {
    return {
      startAdornment: <InputAdornment position="start">£</InputAdornment>,
    }
  }
  if (value === 'Percentage') {
    return { endAdornment: <InputAdornment position="end">%</InputAdornment> }
  }
}

const CreateAdditionalCharge: FC<CreateAdditionalChargesProps> = (props) => {
  const formMethods = useFormContext()
  const [chargeType, setChargeType] = useState('')
  const [chargeTypeName, setChargeTypeName] = useState('')

  const {
    options,
    index,
    isEdit,
    setDrawerVisible,
    additionalCharges,
    setAdditionalCharges,
  } = props
  formMethods.watch('additionalCharges')
  formMethods.watch('additionalCharges')

  return (
    <Grid container spacing={0} sx={styles.inputFormContainer}>
      <Grid item xs={6}>
        <Typography variant="h6" gutterBottom>
          Add additional charge
        </Typography>
      </Grid>
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <FormSelect
            name={`vehicle-additionalCharges.${index}.additionalChargeId`}
            label="Charge type"
            defaultValue=""
            disabled={!isEdit}
            onChange={(e) => {
              setChargeType(e.target.value)
            }}
          >
            <MenuItem value=""></MenuItem>
            {options &&
              options.map((value) => (
                <MenuItem key={value.id} value={value.id}>
                  {value.name}
                </MenuItem>
              ))}
          </FormSelect>
        </Grid>
      </Grid>
      {chargeType !== '' && (
        <>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <FormSelect
                name={`vehicle-additionalCharges.${index}.chargeTypeName`}
                label="Fee type"
                defaultValue=""
                options={FeeType}
                disabled={!isEdit}
                onChange={(e) => {
                  setChargeTypeName(e.target.value)
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <FormInput
                name={`vehicle-additionalCharges.${index}.value`}
                label="value"
                defaultValue=""
                InputProps={getAdornmentProps(chargeTypeName)}
                disabled={!isEdit}
              />
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <FormSelect
                name={`vehicle-additionalCharges.${index}.vATTypeName`}
                label="VAT"
                options={CongestionZoneVAT}
                defaultValue=""
                disabled={!isEdit}
              />
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    name={`vehicle-additionalCharges.${index}.applyMarkup`}
                    onChange={(e) => {
                      formMethods.setValue(
                        `vehicle-additionalCharges.${index}.applyMarkup`,
                        e.target.checked,
                      )
                    }}
                  />
                }
                label="Apply markup"
                disabled={!isEdit}
              />
            </Grid>
          </Grid>
        </>
      )}
      {chargeTypeName && (
        <Grid item>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault()
              const formValues = formMethods.getValues(
                `vehicle-additionalCharges.${index}`,
              )
              const mapped = {
                ...formValues,
                vatTypeName: formValues.vATTypeName,
              }
              setAdditionalCharges([...additionalCharges, mapped])
              setDrawerVisible(false)
            }}
          >
            Save
          </Button>
        </Grid>
      )}
    </Grid>
  )
}
export default CreateAdditionalCharge
